import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMorphemeBoard } from '../../../../mechanics/rid-morpheme-board/rid-morpheme-board';

@Component({
  selector: 'app-morpheme-board-assignments-page',
  imports: [RidMorphemeBoard],
  templateUrl: './morpheme-board-assignments-page.html',
})
export class MorphemeBoardAssignmentsPage {
  protected readonly $router = inject(Router);
}
